module.exports = __webpack_public_path__ + "img/cate_product4.35fbbb0a.png";